import React from 'react';
import { Card, CardHeader, CardBody, CardText } from 'reactstrap';

function RenderEssentials (props) {
    if (props.text !== undefined && props.text !== null) {
        return(
            <div>
                <Card className="card-essentials">
                    <CardHeader>{ props.title }</CardHeader>
                    <CardBody>
                        <CardText>
                            { props.text }
                        </CardText>
                    </CardBody>
                </Card>
            </div>
        );
    } else {
        return (<div></div>);
    }
}

export default RenderEssentials;
